import { loadItem } from '@/services/Storage';

const SERVICE_ID = {
    StandardCallUser: 1,
    RingAllGroup: 2,
    ManagedConference: 11,
    Fax2Mail: 17
};

const LANGUAGE_MAPPING = {
    Deutsch: 'de',
    Englisch: 'en',
    Französisch: 'fr',
    de: 'Deutsch',
    en: 'Englisch',
    fr: 'Französisch',
    userDefined: 'Benutzerdefiniert',
    Benutzerdefiniert: 'userDefined',
};

const INTERNAL_PHONENUMBERS = {
    SmallestInternalNumber: 10,
    LargestInternalNumber: 99
};

const NORMAL_USER_PERMISSIONS = [10, 18, 16, 4, 8, 22, 7, 9, 1, 13, 24, 5, 6, 33, 17, 23, 31, 19];
const ADMIN_USER_PERMISSIONS = [10, 4, 8, 26, 22, 36, 7, 34, 6, 28, 14, 23, 25, 31, 19, 18, 16, 11, 27, 9, 1, 13, 24, 5, 29, 33, 17, 32];

const CLOUD_BASE_URL = 'https://cc-api.starface.de/starfacecc';

const URLS = () => {
    const serverUrl = loadItem('serverUrl');
    return {
        baseUrl: 'https://' + serverUrl + '/rest/',
        urlActiveUser: 'https://' + serverUrl + '/rest/users/me',
        urlUsers: 'https://' + serverUrl + '/rest/users',
        urlPermissions: 'https://' + serverUrl + '/rest/permissions/users',
        urlConference: 'https://' + serverUrl + '/rest/conferenceConfiguration',
        urlPhonenumbers:
            'https://' + serverUrl + '/rest/phonenumbers',
        urlGroups: 'https://' + serverUrl + '/rest/groups',
        urlVoicemailboxes: 'https://' + serverUrl + '/rest/voicemailboxes',
        urlEndingPhoneConfig: '/phonenumberconfig/phonenumbers',
        urlFunctionKeySets: 'https://' + serverUrl + '/rest/functionkeysets/0',
        urlFunctionKeySetsEdit: 'https://' + serverUrl + '/rest/functionkeysets/edit/defaults',

        // Cloud service urls
        cloudUrlNumbers: CLOUD_BASE_URL + '/Numbers',
        cloudUrlAccount: CLOUD_BASE_URL + '/masterdata',
        cloudUrlInvoices: CLOUD_BASE_URL + '/invoices',
        cloudUrlCallsOverview: CLOUD_BASE_URL + '/cdrs',
        cloudUrlRates: CLOUD_BASE_URL + '/packages',
        cloudUrlResetPassword: CLOUD_BASE_URL + '/resetcloudpass',
        cloudUrlGetTariff: CLOUD_BASE_URL + '/sfuptariff/subdomain',
        cloudUrlSetTariff: CLOUD_BASE_URL + '/sfuptariff'
    };
};

export { NORMAL_USER_PERMISSIONS, ADMIN_USER_PERMISSIONS, SERVICE_ID, INTERNAL_PHONENUMBERS, URLS, LANGUAGE_MAPPING };
